import { render } from "./dashboard.vue?vue&type=template&id=29ca66ed&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=29ca66ed&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ca66ed"],['__file',"src/views/index/dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29ca66ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29ca66ed', __exports__)) {
    console.log('reload')
    api.reload('29ca66ed', __exports__)
  }
  
  module.hot.accept("./dashboard.vue?vue&type=template&id=29ca66ed&scoped=true", () => {
    console.log('re-render')
    api.rerender('29ca66ed', render)
  })

}


export default __exports__